module.exports = __webpack_public_path__ + "bc7f5746b8d527760163845fed2cb275.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/table/remove_redesign.png
// module id = 326
// module chunks = 0